import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from 'app/_guards/auth.guard';
import { OrdemServicoComponent } from './ordem-servico.component';

const ordemServicoRoutes: Routes = [
    { path: '', component: OrdemServicoComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(ordemServicoRoutes)],
    exports: [RouterModule]
})
export class OrdemServicoRoutingModule {}